import React from 'react';
import PropTypes from 'prop-types';
import UserReviewEditor from './UserReviewEditor';
import useTitle from '../../Title/hooks/useTitle';
import ResponsiveDrawerAnchor from '../../UI/ResponsiveDrawerAnchor';
import UserReviewEditorProvider from './data/UserReviewEditorProvider';

ReviewEditorAnchor.propTypes = {
	sku: PropTypes.string,
	onUpdate: PropTypes.func,
	children: PropTypes.element,
};

export default function ReviewEditorAnchor({ sku, children, onUpdate }) {
	const { title, isLoading } = useTitle(sku);

	const renderHeader = () => {
		if (isLoading || !title.name) {
			return <span>Your review</span>;
		}
		return (
			<div>
				<span>Your review of </span>
				<em>{title.name}</em>
			</div>
		);
	};

	return (
		<ResponsiveDrawerAnchor
			width={{ mobile: '100%', desktop: '650px' }}
			renderDrawerContent={drawer => (
				<UserReviewEditorProvider sku={sku} onUpdate={onUpdate}>
					<UserReviewEditor drawer={drawer} product={title} />
				</UserReviewEditorProvider>
			)}
			header={<div style={{ padding: 15 }}>{renderHeader()}</div>}>
			{children}
		</ResponsiveDrawerAnchor>
	);
}
